import { render, staticRenderFns } from "./MultipleAddressPicker.vue?vue&type=template&id=56b46232&scoped=true"
import script from "./MultipleAddressPicker.vue?vue&type=script&lang=js"
export * from "./MultipleAddressPicker.vue?vue&type=script&lang=js"
import style0 from "./MultipleAddressPicker.vue?vue&type=style&index=0&id=56b46232&prod&lang=scss&scoped=true"
import style1 from "./MultipleAddressPicker.vue?vue&type=style&index=1&id=56b46232&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b46232",
  null
  
)

export default component.exports